import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const PositiveId = z.coerce.number().int().positive();
const Slug = z.string().min(1);
const MessageResponse = z.string();
const SubmissionResponse = z.object({
    success: z.boolean(),
    message: z.string(),
});
// Answer states carry question-type-specific fields that evolve independently
// across the prosumer activity and project flows.
const AnswerState = z
    .object({
    value: z.string(),
    is_correct: z.boolean().nullable(),
    is_submitted: z.boolean(),
    submitted_at: z.string().nullable(),
    failed_correctness_checks: z.array(z.string()).optional(),
    working_code: z.string().optional(),
    result: z.string().nullable().optional(),
    review: z.string().nullable().optional(),
    does_satisfy_all_requirements: z.boolean().nullable().optional(),
})
    .passthrough();
const ActivitySubmission = z.object({
    difficulty_rating: z.number().nullable(),
    feedback: z.string().nullable(),
    activity_session_id: PositiveId,
    seconds_spent: z.number().nonnegative(),
    activity_id: PositiveId,
    answer_states: z.record(AnswerState),
});
const ProjectSubmission = ActivitySubmission;
const AIReviewActivityRequest = z.object({
    submissionId: PositiveId,
    activitySlug: Slug,
    questionSlugToAnswer: z.record(z.unknown()).optional(),
});
const AIReviewProjectRequest = z.object({
    sessionId: PositiveId,
    projectSlug: Slug,
});
export const submitProsumerActivityRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/{contentSlug}/activities/submit',
    name: 'submit-activity-prosumer',
    request: {
        params: z.object({ contentSlug: Slug }),
        body: ActivitySubmission,
    },
    responses: { 200: MessageResponse, 400: HttpErrorResponse },
};
export const submitProsumerProjectRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/projects/{projectSlug}/submit',
    name: 'submit-prosumer-project',
    request: {
        params: z.object({ projectSlug: Slug }),
        body: ProjectSubmission,
    },
    responses: { 200: MessageResponse, 400: HttpErrorResponse },
};
export const createProsumerAIReviewRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/aireview',
    name: 'create-prosumer-ai-review',
    request: { body: AIReviewActivityRequest },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const submitProsumerProjectAnswerRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/projects/{projectSlug}/submit-answer/',
    name: 'submit-prosumer-project-exercise-answer',
    request: {
        params: z.object({ projectSlug: Slug }),
        body: z.object({
            value: z.string().min(1),
            submissionId: PositiveId,
            questionSlug: Slug,
        }),
    },
    responses: { 200: SubmissionResponse, 400: HttpErrorResponse },
};
export const submitProsumerAnswerRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/submit-answer/',
    name: 'submit-prosumer-answer-attempt',
    request: {
        body: z.object({
            value: z.string().min(1),
            submissionId: PositiveId,
            questionSlug: Slug,
        }),
    },
    responses: { 200: SubmissionResponse, 400: HttpErrorResponse },
};
export const createProsumerProjectAIReviewRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/projects/{projectSlug}/aireview',
    name: 'create-prosumer-project-ai-review',
    request: {
        params: z.object({ projectSlug: Slug }),
        body: AIReviewProjectRequest,
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
